export default __webpack_public_path__ + "static/media/pie_inicio-01.866ace67.png";